import React, { useEffect, useState } from 'react';
import { SPLeadModel } from '../models/superbit-api-models';
import moment from 'moment';
import { Dropdown, MenuProps, Select, Tooltip } from 'antd';
import './lead-row-item.css';
import generalSettings from '../json/general-settings.json';

import LeadItemRowDetails from './_LeadItemRowDetails';
import CallButton from '../components/_CallButton';
import { GeneralDataModel } from '../models/GeneralDataModel';

type Props = {
    details: SPLeadModel;
    config?: any;
    actions?: Function[]
};

const LeadItemRow =(props: Props)=> {
    const [item, setItem] = useState<any>(props.details);
    const [statuses, setStatuses] = useState<any[]>([]);
    const [statusLabel, setStatusLabel] = useState<string>('N/A');
    const [propertyLabel, setProppertyLabel] = useState<string>('N/A');
    const [showStatusSelect, setShowStatusSelect] = useState<boolean>(false)
    const [dropdownItems, setDropdownItems] = useState<MenuProps['items']>([]);
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [policyTypes, setPolicyTypes] = useState<any>(generalSettings.policyTypes);
    // const [apiUrl, setApiUrl] = useState<string>('');
    const leadStatusSelect = React.createRef<any>();

    const getPropertyLabel = () => {
        const propertyTypes = [
            "דירה",
            "משרד",
            "בית פרטי",
            "עסק"
        ];
        let propertyType = propertyTypes[0];
        if(item && item.lead && item.lead.propertyType) {
            propertyType = propertyTypes[item.lead.propertyType];
        }

        return propertyType;
    }

    const onRowClick = (e: any)=>{
        if (e.target.parentElement.className.indexOf('on-row-click-ignore') >= 0 || e.target.className.indexOf('on-row-click-ignore') >= 0) {
            return;
        } 
        setShowDetails(!showDetails);
        console.log('onRowClick', e)
    }

    const onCallStart = (e:any) => {
        e.stopPropagation();
        
        if(item.lead.phoneNumber11) {
            new GeneralDataModel().speakComSendCall(item.lead.phoneNumber1, item.lead.id);
        }
    }

    // const buildPolyTypes = () => {
    //     const
    // }

    const emptyFunc = (value?: string) => {}
    
    useEffect(()=>{
        setDropdownItems(
            [
                {
                    key: '1',
                    label: (
                        <div className="pointer rtl"
                            onClick={()=>{emptyFunc('_EDIT_LEAD_')}}
                        >
                            ערוך
                        </div>
                    ),
                },
                {
                    label: 
                        <div className="pointer rtl"
                            onClick={()=>{emptyFunc('_DLETE_LEAD_')}}
                        >
                            מחק
                        </div>,
                    key: '2',
                },
                {
                    label: 
                        <div className="pointer rtl"
                            onClick={()=>{emptyFunc('_PRINT_LEAD_')}}
                        >
                            הדפס
                        </div>,
                    key: '3',
                },
                {
                    label: 
                        <div className="pointer rtl"
                            onClick={()=>{emptyFunc('_GOTO_SIMULATOR_')}}
                        >
                            סימולטור
                        </div>,
                    key: '4',
                },
                

            ]
        );
    },[])
    useEffect(()=>{
        console.log('New LeadItemRow', item)
    },[item])

    useEffect(()=>{
        let statuses: any[] = []
        const leadStatusesList = localStorage.getItem('leadStatuses');
        if (leadStatusesList) {
            statuses = JSON.parse(leadStatusesList)
            setStatuses(statuses);
        }
        const itemStatus = statuses.find((s: any) => s.value == item.lead.lastStatusId);
        setStatusLabel(item.lastStatusName);
        // if (itemStatus){
        //     setStatusLabel(itemStatus.text)
        // }
        setProppertyLabel(getPropertyLabel());
        console.log('New list loaded', props.details)

    }, [props])


    // 
    // if (leadStatuses.length==0) {
    //     const statuses = await leadsModel.getLeadStatuses();
    // }
    
    return (
        <>  
            {/* <div className='leads-table-row data-table-row'>
                <div className="cell icon">
                    <div className="description cell-value">
                        <div className="icon tag"></div>
                    </div>
                </div>
                <div className="cell status">
                    <div className="flex-end">
                        <div className={`status flex-centered flex-space-between ${!showStatusSelect ? '' : 'hide'}`} onClick={()=>emptyFunc()}>
                            <div className="status-circle"></div>
                            <div className="sub-title">{statusLabel}</div>
                            <div className="qty">
                                <div className={item.lead.doubleLead?"qty-circle":"hide"}></div>
                                <div className={item.lead.doubleLead?"qty-number flex-centered flex-justify-center":"hide"}>x2</div>
                            </div>
                        </div>
                        <div className={`${showStatusSelect ? '' : 'hide'}`}>                                    
                            <Select ref={leadStatusSelect}
                                allowClear
                                style={{ width: '100%' }}
                                defaultValue={item.lead.lastStatusId}
                                onChange={(v: string)=>emptyFunc()}
                                options={item.leadStatuses && item.leadStatuses.map(
                                        (item: any)=>({label: item.text, value: item.value}))}
                            />
                        </div>
                    </div>
                </div>
                <div className="cell date-field">
                    <div className="description cell-value bold">
                        20-08-2024
                    </div>
                    <div className="description">
                        21:00
                    </div>
                </div>
                <div className="cell branch-name">
                    <div className="title">סניף</div>
                    <div className="description cell-value bold">
                        BRANCH
                    </div>
                </div>
                <div className="cell position-name">
                    <div className="title">עמדה</div>
                    <div className="description cell-value">
                        Station
                    </div>
                </div>
                <div className="cell handler-name">
                    <div className="title">מטפל</div>
                    <div className="description cell-value">
                    ישראל ישראלי
                    </div>
                </div>
                <div className="cell contact-name">
                    <div className="title">איש קשר</div>
                    <div className="description cell-value bold">
                        דוויד שחימטוב
                    </div>
                </div>
                <div className="cell phone-number on-row-click-ignore">
                    <div className="title">טלפון</div>
                    <div className="description bold cell-value phone-number">
                        054-1234321
                    </div>
                </div>
                <div className="cell icon document-cell">
                    <div className="icon paperclip pointer" 
                        onClick={()=>emptyFunc()}>
                    </div>
                </div>
                <div className="cell asset-name on-row-click-ignore">
                    <div className="title">נכס</div>
                    <div className="sub-title">414557</div>
                    <div className="description">לקסוס RX-300 לקצ'ורי (2000) 4X4 אוטו' 238 כ"ס</div>
                </div>
                <div className="cell lead-type">
                    <div className="title">
                        סוג ליד
                    </div>
                    <div className="description bold">
                        רכב
                    </div>
                </div>
                <div className="cell year-field">
                    <div className="title">שנה</div>
                    <div className="sub-title">
                        2022
                    </div>
                </div>
                <div className="cell notes">
                    <div className="title">
                        הערות
                    </div>
                    <div className="description cell-value on-row-click-ignore">
                        <div className='icon info pointer'></div>
                    </div>
                </div>
                <div className="cell date-field">
                    <div className="description cell-value">
                    11-04-2024
                    </div>
                </div>
                <div className="cell actions flex-space-between">
                    <Dropdown menu={{ items: [] }}>
                        <div className="act-btn-icon icon menu-hamburger pointer on-row-click-ignore"></div>
                    </Dropdown>
                    <div className='icon left-arrow pointer'></div>
                </div>
            </div> */}
            <div className={`lead-item-row-container ${showDetails ? 'opened' : 'closed'}`}>
                <Dropdown menu={{ items: dropdownItems }} trigger={['contextMenu']}>
                    <div className={`data-card lead-item-row flex-space-between ${showDetails ? 'opened' : 'closed'}`} onClick={onRowClick}>
                        <div className="data-card-body flex-space-between">
                            <div className="cell icon">
                                <div className="description cell-value">
                                    <div className={item.lead!=null && (item.lead as any).simulatorOfferStage>=0?"icon tag":""}></div>
                                </div>
                            </div>
                            <div className="cell status">
                                <div className="flex-end">
                                    <div className={`status flex-centered flex-space-between ${!showStatusSelect ? '' : 'hide'}`} onClick={()=>emptyFunc()}>
                                        <div className="status-circle"></div>
                                        <div className="sub-title">{statusLabel}</div>
                                        <div className="qty">
                                            <div className={item.lead.doubleLead?"qty-circle":"hide"}></div>
                                            <div className={item.lead.doubleLead?"qty-number flex-centered flex-justify-center":"hide"}>x2</div>
                                        </div>
                                    </div>
                                    <div className={`${showStatusSelect ? '' : 'hide'}`}>                                    
                                        <Select ref={leadStatusSelect}
                                            allowClear
                                            style={{ width: '100%' }}
                                            defaultValue={item.lead.lastStatusId}
                                            onChange={(v: string)=>emptyFunc()}
                                            options={item.leadStatuses && item.leadStatuses.map(
                                                    (item: any)=>({label: item.text, value: item.value}))}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="cell date-field">
                                <div className="description cell-value bold">
                                    {moment(item.lead.createdDate).format('DD-MM-YYYY')}
                                </div>
                                <div className="description">
                                    {(moment(item.lead.createdDate)).format('HH:mm')}
                                </div>
                            </div>
                            <div className="cell branch-name">
                                <div className="title">סניף</div>
                                <div className="description cell-value bold">
                                    {item.lead.branchesPath}
                                </div>
                            </div>
                            <div className="cell position-name">
                                <div className="title">עמדה</div>
                                <div className="description cell-value">
                                {item.lead.stationUser!=null?item.lead.stationUser.fullName:""}
                                </div>
                            </div>
                            <div className="cell handler-name">
                                <div className="title">מטפל</div>
                                <div className="description cell-value">
                                {item.lead.handler!=null?item.lead.handler.fullName:""}
                                </div>
                            </div>
                            <div className="cell contact-name">
                                <div className="title">איש קשר</div>
                                <div className="description cell-value bold">
                                    {item.lead!=null?item.lead.firstName+" "+item.lead.lastName:""}
                                </div>
                            </div>
                            <div className="cell phone-number on-row-click-ignore">
                                <div className="title">טלפון</div>
                                <div className="description bold cell-value phone-number">
                                    {item.lead.phoneNumber1}
                                    <CallButton onStart={(e:any)=>onCallStart(e)} user={{
                                        userName: `${item.lead.firstName} ${item.lead.lastName}`,
                                        userPhone: item.lead.phoneNumber1
                                    }} />
                                </div>
                            </div>
                            <div className="cell icon document-cell">
                                <div className={item.lead.carLicenseFilePath || (item.lead.vehicle!=null && typeof item.lead.vehicle.carLicenseFilePath!='undefined' && item.lead.vehicle.carLicenseFilePath)?"icon paperclip pointer":"" } 
                                    onClick={()=>emptyFunc()}></div>
                            </div>
                            <div className="cell asset-name on-row-click-ignore">
                                <div className="title">נכס</div>
                                {
                                    item.lead.leadTopType == 0 ? (<>
                                        <div className="sub-title">{item.lead.vehicle!=null && item.lead.vehicle.vehicleSubModel!=null ? item.lead.vehicle.vehicleSubModel.modelCode:""}</div>
                                        <div className="description">{item.lead.vehicle!=null && item.lead.vehicle.vehicleSubModel!=null ? item.lead.vehicle.vehicleSubModel.name:""}</div>
                                        <div className="description">{item.lead.vehicle!=null && item.lead.vehicle.vehicleSubModel!=null ? item.lead.vehicle.licenseNumber:""}</div>
                                    </>) : ''
                                }
                                {
                                    item.lead.leadTopType == 1 && item.lead.involvedAddress ? (<>
                                        <div className="sub-title">{propertyLabel}</div>
                                        <div className="description">{item.lead.involvedAddress.street} {item.lead.involvedAddress.houseNumber}/{item.lead.involvedAddress.apartmentNumber} {item.lead.involvedAddress.city}</div>
                                    </>) : ''
                                }
                                {
                                    item.lead.leadTopType == 2 ? (<>
                                        <div className="sub-title">
                                            אחר
                                        </div>
                                        {item.lead.policyType ? (
                                            <div className="description" title={policyTypes[item.lead.policyType].description}>
                                                {policyTypes[item.lead.policyType].description} <br />
                                            </div>
                                            ) : ''
                                        }
                                        
                                    </>) : ''
                                }
                            </div>
                            <div className="cell lead-type">
                                <div className="title">
                                    סוג ליד
                                </div>
                                {/* <div className="sub-title">
                                    {this.state.leadTopTypeLabel}
                                </div> */}
                                <div className="description bold">
                                    {/* {this.state.leadTypeLabel} */}
                                </div>
                            </div>
                            <div className="cell year-field">
                                <div className="title">שנה</div>
                                {
                                    item.lead.leadTopType == 0 ? (<>
                                        <div className="sub-title">
                                            {item.lead.vehicle!=null && item.lead.vehicle.vehicleSubModel!=null ? item.lead.vehicle.carYear : ""}
                                        </div>
                                    </>) : ''
                                }
                            </div>
                            
                            <div className="cell notes">
                                <div className="title">
                                    הערות
                                </div>
                                <div className="description cell-value on-row-click-ignore">
                                    {item.lead.internalComment && item.lead.internalComment !== '' ? (<>
                                        <Tooltip title={item.lead.internalComment} color={'#027BFD'} placement="right">
                                            <div className='icon info pointer'></div>
                                        </Tooltip>
                                    </>) : (<></>)}
                                </div>
                            </div>
                            <div className="cell date-field">
                                <div className="description cell-value">
                                {item.lead.deliveryDate && moment(item.lead.deliveryDate).isValid() ? moment(item.lead.deliveryDate).format('DD-MM-YYYY') : ''}
                                </div>
                            </div>
                            <div className="cell actions flex-space-between">
                                <Dropdown menu={{ items: dropdownItems }}>
                                    <div className="act-btn-icon icon menu-hamburger pointer on-row-click-ignore"></div>
                                </Dropdown>
                                <div className={`icon left-arrow pointer ${showDetails ? 'toggle-leed' : ''}`} onClick={()=>setShowDetails(!showDetails)}></div>
                            </div>
                        </div>
                    </div>
                </Dropdown>
                <div className={`${showDetails ? '' : 'hide'}`}>
                    <LeadItemRowDetails data={item} />
                </div>

            </div>
        </>
    )
}

export default LeadItemRow;